import { Component, OnInit, AfterViewInit, Input } from '@angular/core';
import { ChartSpecification } from '../../../../dataModels/chart-data-model';

declare var AmCharts;

@Component({
    selector: 'funnel-3d-chart',
    templateUrl: 'funnel-3d-chart.component.html',
    styleUrls: ['funnel-3d-chart.component.css', '../../charts.style.scss']
})

export class Funnel3DChartComponent implements OnInit, AfterViewInit {
    @Input() chartSpecification: ChartSpecification;

    constructor() { }

    ngOnInit() {
        this.chartSpecification.title = this.chartSpecification.title || "";
        this.chartSpecification.theme = this.chartSpecification.theme || "none";
        this.chartSpecification.chartColor = this.chartSpecification.chartColor || "";
        this.chartSpecification.data = this.chartSpecification.data || [];
        this.chartSpecification.yAxisTitle = this.chartSpecification.yAxisTitle || "";
        this.chartSpecification.xAxis = this.chartSpecification.xAxis || "xAxis";
        this.chartSpecification.yAxis = this.chartSpecification.yAxis || "yAxis";
        this.chartSpecification.divId = this.chartSpecification.divId || "funnelDiv";
    }

    ngAfterViewInit() {
        this.drawChart();
    }

    drawChart() {
        setTimeout(() => {
            AmCharts.makeChart(this.chartSpecification.divId, {
                "hideCredits": true,
                "type": "funnel",
                "theme": this.chartSpecification.theme,
                "dataProvider": this.chartSpecification.data,
                "titles": [{
                    "size": 12,
                    "text": this.chartSpecification.title
                }],
                "balloon": {
                    "fixedPosition": true
                },
                "valueField": this.chartSpecification.yAxis,
                "titleField": this.chartSpecification.xAxis,
                "marginRight": 240,
                "marginLeft": 50,
                "startX": -500,
                "depth3D": 40,
                "angle": 40,
                "outlineAlpha": 1,
                "outlineColor": "#FFFFFF",
                "outlineThickness": 0,
                "labelPosition": "right",
                "labelText": "[[title]]",
                "balloonText": "[[title]]: [[value]]n[[description]]",
                "export": {
                    "enabled": true,
                    "fileName": this.chartSpecification.title
                }
            });
        }, 20);
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/charts/funnelCharts/funnel-3d-chart/funnel-3d-chart.component.ts